var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',[(_vm.visible)?_c('div',{staticClass:"pre-loader"},[_c('LottieLoader',{attrs:{"size":210}}),_c('Transition',{attrs:{"name":"loader-text","mode":"out-in"}},[_c('p',{key:_vm.currentMessage,staticClass:"pre-loader__message"},[_vm._v(_vm._s(_vm.currentMessage))])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }